// @ts-nocheck
import React from 'react';
import { sx } from '../sx';

export default function DeleteRowButton({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      className="gmHover"
      aria-label={label}
      title={label}
      onClick={onClick}
      style={sx(`flex:none;width:20px;height:20px;display:flex;align-items:center;justify-content:center;border:none;border-radius:4px;background:none;color:#E5484D;cursor:pointer;padding:0`)}
      data-hover="background:#FDECEC"
    >
      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"><path d="M1 3h10M4.5 3V1.8h3V3M2.5 3l.6 8.4a1 1 0 0 0 1 .9h3.8a1 1 0 0 0 1-.9L9.5 3M5 5.5v4.2M7 5.5v4.2"></path></svg>
    </button>
  );
}
